import React from 'react';
import { AuthenticatedProps, makeAuthenticatedComponent } from '../../context/authentication';
import {
  Menu,
  MenuTrigger,
  Button,
  MenuPopover,
  MenuList,
  MenuItem,
  MenuGroup,
  makeStyles,
  MenuItemSwitch,
  MenuProps,
} from '@fluentui/react-components';
import { PersonCircle20Regular } from '@fluentui/react-icons';
import { useAppActions, useAppState } from '../../context';

const useStyles = makeStyles({
  headerContentButton: {
    minWidth: 'unset',
  },
});

function AppHeaderPersonaAuth(props: AuthenticatedProps<Record<never, unknown>>): JSX.Element {
  const styles = useStyles();
  const appState = useAppState();
  const appActions = useAppActions();

  const onCheckedValueChange: MenuProps['onCheckedValueChange'] = (_, data) => {
    if (data.name === 'editMode') {
      if (data.checkedItems.includes('checked')) {
        appActions.view.enterEditMode();
      } else {
        appActions.view.leaveEditMode();
      }
      return;
    }
  };

  return (
    <Menu
      onCheckedValueChange={onCheckedValueChange}
      checkedValues={{ editMode: appState.view.inEditMode ? ['editMode', 'checked'] : ['editMode'] }}
    >
      <MenuTrigger>
        <Button appearance="primary" className={styles.headerContentButton}>
          <PersonCircle20Regular />
        </Button>
      </MenuTrigger>
      <MenuPopover>
        <MenuList>
          <div>Welkom {props.authentication.user.firstname}</div>
          <MenuItem>Account</MenuItem>
          <MenuGroup>
            <MenuItemSwitch name="editMode" value="checked">
              Edit mode
            </MenuItemSwitch>
            <MenuItem>Logout</MenuItem>
          </MenuGroup>
        </MenuList>
      </MenuPopover>
    </Menu>
  );
}

export const AppHeaderPersona = makeAuthenticatedComponent(AppHeaderPersonaAuth);
export default AppHeaderPersona;
